import React from 'react';
import TopSection from 'js/components/Common/TopSection/TopSection';
import Overview from 'js/components/Common/Overview/Overview';
import LearningPath from 'js/containers/PostTypes/SelfLearning/LearningPath/LearningPath';

const SelfLearning = ({ pageId }) => (
    <main className="SelfLearning">
        <TopSection pageId={pageId} pageType={'post'}/>
        <Overview pageId={pageId} pageType={'SelfLearning'}/>
        <LearningPath pageId={pageId} />
    </main>
);

export default SelfLearning;

